export default __webpack_public_path__ + "static/media/senobi_trac.b131cb15.png";